const RaidSettingsPage = () => {
	return (
		<h1>Raid Settings</h1>
	);
}

export default RaidSettingsPage;